export default !!(typeof navigator !== 'undefined' &&
navigator.userAgent &&
/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent))
